<app-layout type="white" size="100%">
  <app-breadcrumb [breadcrumbItems]="[
    { label: ('breadcrumb.login' | translate), link: '/' },
    { label: ('breadcrumb.register' | translate) }
  ]"></app-breadcrumb>

  <div class="register-content">
    <app-title title="register.complete.title" />

    <app-stepper
      [steps]="['register.stepper.step1', 'register.stepper.step2', 'register.stepper.step3']"
      [currentStep]="2"
    />

    <p class="message">{{ 'register.complete.message' | translate }}</p>

    <app-button variant="primary">
      <a routerLink="/" queryParamsHandling="preserve">{{ 'register.complete.login' | translate }}</a>
    </app-button>
  </div>
</app-layout>
